import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import styled from "styled-components";
import { Breadcrumb, Title } from "../../../css/commun";
import { URL_Dev } from "../Variables";
import { fetchWpCached, filterPortfolioByLanguage, getWpCachedSeed } from "../../../api/wpClient";
import { ListPortfolio } from "./ListPortfolio";
import Pages from "../../../Model/Pages";
import SeoHead from "../../Seo/SeoHead";
import { withTranslation } from "react-i18next";
import ReactGA from "react-ga";
import cookies from "js-cookie";
import { TailSpin } from 'react-loader-spinner';
import './Portfolio.css'
const Portfolios = (props) => {
  const title = props.location.pathname
  const splitState = title.split('/')
  const staticTitles = {
    en: "Nos Réalisations",
    fr: "Nos Réalisations"
  };
  const { t } = props;
  const currentLanguage = cookies.get('i18next') || 'fr'
  const seededItems = filterPortfolioByLanguage(
    getWpCachedSeed("portfolioList") || [],
    currentLanguage
  );
  const [items, setItems] = useState(seededItems);
  const [portfolioCategori, setPortfolioCategori] = useState(0);
  const [number, setNumber] = useState(12)
  const [pages, setPages] = useState([]);
  const [langue, setLangue] = useState("fr");
  const [titre, setTitre] = useState(staticTitles[currentLanguage]);
  const [lastChecked, setLastChecked] = useState(null);
  const [loading, setLoading] = useState(seededItems.length === 0)


  useEffect(() => {
    setLangue(currentLanguage);
    document.body.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr';
    setItems(seededItems);
    setLoading(seededItems.length === 0);
  
    const fetchPortfolio = async () => {
      try {
        const allPortfolios = await fetchWpCached("portfolioList", {
          onRevalidated: (data) => setItems(filterPortfolioByLanguage(data, currentLanguage)),
        });
        setItems(filterPortfolioByLanguage(allPortfolios, currentLanguage));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching portfolio:", error);
        setLoading(false);
      }
    };

    fetchPortfolio();
  }, [currentLanguage]);
  

  const scrollToEnd = () => {
    setNumber(number + 3)
  }

  window.onscroll = function () {
    if (window.innerHeight + document.documentElement.scrollTop > (document.documentElement.offsetHeight - 300)) {
      scrollToEnd()
    }
  }
  const cacheTitle = (result) => {
    const page = result.find(element =>
      decodeURI(element.slug) === (splitState[1].length === 2 ? splitState[2] : splitState[1])
    );

    if (page) {
      const title = page.title.rendered.replace("&#8217;", "'");
      if (title !== titre) {
        setTitre(title);
      }
      setLastChecked(new Date().getTime()); 
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    ReactGA.pageview(window.location.pathname);

    const oneMonth = 30 * 24 * 60 * 60 * 1000;
    const lastCheckedTimestamp = lastChecked || 0;

    if (new Date().getTime() - lastCheckedTimestamp >= oneMonth) {
      fetchWpCached("pages", { onRevalidated: (result) => { setPages(result); cacheTitle(result); } })
        .then((result) => {
          setPages(result);
          cacheTitle(result);
        });
    }
  }, [lastChecked]);

  const filteredItems = portfolioCategori === 0
    ? items
    : items.filter((element) => element.categoriesportfolio?.includes(portfolioCategori));

  const portfolio = filteredItems.map((element) => ({
    id: element.id,
    title: element.title?.rendered || '',
    slug: element.slug,
    image:
      element._embedded?.['wp:featuredmedia']?.[0]?.source_url ||
      element.featured_image_url ||
      element.x_featured_media_large ||
      '',
    isLightweight: Boolean(element.is_lightweight),
  }))

  let page = []
  pages.map(element =>
    decodeURI(element.slug) === (splitState[1].length === 2 ? splitState[2] : splitState[1]) &&
    page.push(new Pages(element.id, element.title.rendered, element.content.rendered, element.parent, element.slug, element.yoast_head_json.og_description,element.yoast_head_json.title, element.date, element.excerpt.rendered)))

  return (
    <>
      <SeoHead
        title={page[0]?.metatitle || titre}
        description={page[0]?.description}
        pathname={props.location.pathname}
        image={`${URL_Dev}/images/oxton.png`}
      />
      <div className="container" >
      <Breadcrumb>
        <p>
          <Link className="retour" to="/">{t('Home_link')}</Link> / <span>{titre}</span>
        </p>
      </Breadcrumb>
        <Table>
          <Title>
            <h1>{titre}</h1>
            <p className="title-p">Découvrez ci-dessous une sélection d’études de cas détaillées, parmi les 100 projets réalisés par Oxton-digital. Vous pouvez également découvrir les dernières réalisations (sites, apps, vidéos, identités visuelles, etc.) ou les projets par secteur.</p>

          </Title>
          <div className="listBotton">
            <button type="button" className={portfolioCategori === 0 ? "btn  active" : "btn "} onClick={() => (setPortfolioCategori(0), setNumber(6))}>{t('Portfolio.All')}</button>

            <button type="button" className={portfolioCategori === 5 ? "btn  active" : "btn "} onClick={() => (setPortfolioCategori(5), setNumber(6))}>{t('Portfolio.Web_development')}</button>
      
            <button type="button" className={portfolioCategori === 6 ? "btn btn-mobile active" : "btn btn-mobile "} onClick={() => (setPortfolioCategori(6), setNumber(6))}>{t('Mobile')}</button>
          
            <button type="button" className={portfolioCategori === 7 ? "btn btn-design active" : "btn btn-design "} onClick={() => (setPortfolioCategori(7), setNumber(6))}>{t('Portfolio.UX_UI_Design')}</button>
         
            <button type="button" className={portfolioCategori === 9 ? "btn btn-borne  active" : "btn btn-borne"} onClick={() => (setPortfolioCategori(9), setNumber(6))}>{t('Kiosk')}</button>
           
          </div>
          {loading
            ? <div className="loading">
              <TailSpin color="#17406F" />
            </div>
            : <>
              <ListPortfolio portfolio={portfolio} number={number} langue={langue} />
              {(portfolioCategori === 0 && number < items.length) ? (
                <div className="loading" onClick={() => setNumber(number + 9)}>
                  <TailSpin color="#17406F" />
                </div>
              ) : number < portfolio.length && (
                <div className="loading" onClick={() => setNumber(number + 3)}>
                  <TailSpin color="#17406F" />
                </div>
              )}

            </>}
        </Table>
      </div >
    </>)
}


export const Table = styled.div`
// h1 {
// color:#20ACE3 !important;
//     font-family: 'RalewayRegular';
//     font-weight: 600;
//     font-size: 42px !important;

// }
 p{
 font-size:18px;
 margin-bottom:0px !important ;
 }
 
  .listBotton{
    padding:30px 0px ;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px; 
    @media (max-width: 1400px){
      padding: 30px 0px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 12px;
    }
      @media (max-width: 1199px){
       grid-template-columns: repeat(3, 1fr);
    
      }
       @media (max-width: 1199px) and (min-width: 861px){
           padding-right:10px;
       }
       @media(max-width: 767px){
       grid-template-columns: repeat(2, 1fr);
       }
   
    @media (max-width: 575px) {
        padding: 20px 0px 0px 0px;
        margin: 0 20px;
        margin-bottom: 25px;
}
    >.btn{
      border: 1px solid #17406F;
    font-family: InterRegular;
    font-size: 18px;
    color: black;
    margin-right: 0px;
    margin-bottom: 40px;
    width: auto;
    height: auto;
    border-radius: 6px !important;
    @media (max-width:1400px) {
    margin-bottom: 18px;
        width: auto;
    }
      @media (max-width:991px) {
        margin-bottom: 18px;
      }
      @media (max-width:500px) and (min-width: 431px){
        border-radius: 4px !important;
        width: 45%;
      }
       @media (max-width:576px){
        border: 1px solid rgb(23, 64, 111);
        font-family: InterRegular;
        font-size: 14px;
        width: auto;
        height: auto;
        border-radius: 6px !important;
       }
      &:hover{
          background-color: #17406F;
          color: #fff;
          box-shadow: none !important;
        }
      }
    .active{
    background-color: #17406F;
    color: #fff;
        box-shadow: none !important;
    }
    .active + div {
      display:block!important;
      position:absolute;
      margin-top: 80px;
      @media (max-width:991px) {
        display:none!important;
      }
    }
  }
  >.loading{
    display: flex;
    justify-content: center;
  } 
  >.table{
    display:flex ;
    flex-direction:row ;
    justify-content:center;
    gap:20px;
    @media (max-width: 767px){
      flex-direction: column;
    }
    >.link{
      text-align: center;
  
      border: 0px;
      width: 25%;
      flex: 0 0 49%;
      min-width: 17rem;
      @media (max-width:1199px) {
        flex: 0 0 48%;
      }
      @media (max-width:1555px) {
        width: 33%;
      }
      @media (min-width: 815px) and (max-width: 1187px) {
        width: 50%
      }
      @media (max-width: 814px) {
        width: 100%
      }
     
      >.card{
        border-radius: 6px;
        border: 1px solid #17406F;
        background-color: #fff;
        padding: 20px;
        @media (min-width: 814px) {
          height: 100%;
         }
        @media (max-width: 576px) {
           padding:15px;
          } 
      &:hover{
        background-color:#20ACE3;
        box-shadow: 0px 5px 11px 0px #20ACE366;
        border: 1px solid #20ACE3;
       svg path{
       fill:white;
       }
        .card-body h3{
        color:white;
        }
}
          
        >.image{
          padding: 0;
          // height: 290px;
          @media (max-width:2100px) {
           
          }
          @media (max-width:814px) {
            // height: 350px;
          }
          @media (max-width:550px) {
            // height: 300px;
          }
          @media (max-width:440px) {
            // height: 250px;
          }
        }
        >.image >img{
          padding:0;
          width:100%;
          border-radius:5px;
          height: 100%;
          object-fit: cover;
          border-top:20px;
        } 
        >.card-body{
          padding-top:20px;
          height: auto;
          padding-bottom: 0;
          >.card-header {
        
            background-color: transparent;
            border: 0;
            padding: 0.2rem 0;
             
              }
            h3{
            color: #17406F;
   

    font-family: RalewayRegular;
    font-weight: 500;
    margin-bottom: 0px;
    font-size: 20px !important;
    line-height: 24px !important;
    text-align: left;
    @media(max-width:830px){
           font-size: 17px !important;
          line-height: 20px !important;
      }
      @media(max-width:576px){
           font-size: 15px !important;
          line-height: 20px !important;
      }
    
    }
          }
          >p{
            position: relative;
            >.url{
            font-weight: 600;
            }
            >span{
              color: #17406F;
            }
          }
        }
      }
    }
  }
  >.table{
    
  }
  >img{
    padding-top: 30px;
  }

  >.arrow{
    cursor: pointer;
    position: relative;
    left: 50%;
  }
`;

export default withTranslation()(Portfolios)

